import { Directive, ElementRef, OnInit, Renderer2, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';

@Directive({
selector: '[appValidation]'
})
export class ValidationDirective implements OnInit {
  private element: HTMLInputElement;
  @Output("appValidation") stopPropEvent = new EventEmitter();
  unsubscribe;

  constructor(private elRef: ElementRef, private renderer : Renderer2) {
    this.element = elRef.nativeElement;
  }
  ngOnInit() {
    this.unsubscribe = this.renderer.listen(this.element, "click", event => {
    const array = Array.from(this.element.form.classList);
    const elementArray = Array.from(this.element.form.elements);
    const recap = document.getElementById("g-recaptcha-response");
    console.log(elementArray);
    console.log(array);
    if(event.type === 'click' && (array.indexOf('ng-valid') === -1)){
    event.preventDefault();
    event.stopPropagation();
    elementArray.forEach(el => {
    if(document.getElementById("req"+el.id) != undefined){
    document.getElementById("req"+el.id).remove();
    }
    const classArray = Array.from(el.classList);
    if((classArray.indexOf('ng-invalid') !== -1 && (el['hidden'] !== true && el['type'] !== 'file')) ||((el['type'] != 'button' && el['type'] != 'submit') && el['value'] === "" && el['name'] !== 'supMail' && el['type'] !== 'file' && (el['hidden'] !== true))){
    const node = document.createElement("DIV");
    node.classList.add("text-form");
    node.classList.add("text-danger");
    node.setAttribute("id", "req"+el.id);
    let textnode;
    if(el['name'] == 'supMail'){
      textnode = document.createTextNode("* Invalid Email");
    }
    else{
      textnode = document.createTextNode("* Required Field");
    }
    node.appendChild(textnode);
    el.parentElement.appendChild(node);
    }
    });
    console.log($("form"));
    }
    else if(elementArray.indexOf(recap) !== -1 && recap['value'] === ""){
      event.preventDefault();
      event.stopPropagation();
      elementArray.forEach(el => {
      if(document.getElementById("req"+el.id) != undefined){
      document.getElementById("req"+el.id).remove();
      }
      const classArray = Array.from(el.classList);
      if(classArray.indexOf('ng-invalid') !== -1 ||((el['type'] != 'button' && el['type'] != 'submit') && el['value'] === "")){
      const node = document.createElement("DIV");
      node.classList.add("text-form");
      node.classList.add("text-danger");
      node.setAttribute("id", "req"+el.id);
      const textnode = document.createTextNode("* Required Field");
      node.appendChild(textnode);
      el.parentElement.appendChild(node);
      }
      });
      }
      else{
      this.stopPropEvent.emit(event);
      }
      });
      }
      ngOnDestroy() {
      this.unsubscribe();
      }
    }  


// WEBPACK FOOTER //
// ./src/app/validation.directive.ts